export const NAME = 'store';